import React from "react";
import "./ProductDetail126.css";

function ProductDetail126() {
  const features = [
    {
      icon: "bi-speedometer2",
      title: "Real-Time Monitoring",
      desc: "Track tire pressure and temperature instantly with live updates.",
    },
    {
      icon: "bi-bell",
      title: "Instant Alerts",
      desc: "Get notified immediately for pressure drops or overheating issues.",
    },
    {
      icon: "bi-graph-up",
      title: "Analytics Dashboard",
      desc: "Visual insights and reports for better fleet performance decisions.",
    },
    {
      icon: "bi-wifi",
      title: "Wireless Sensors",
      desc: "Advanced wireless sensors ensure accurate and continuous data.",
    },
    {
      icon: "bi-shield-check",
      title: "Safety First",
      desc: "Prevent accidents and improve road safety with proactive monitoring.",
    },
    {
      icon: "bi-cloud",
      title: "Cloud Sync",
      desc: "Access your data anywhere with secure cloud integration.",
    },
  ];

  return (
    <section className="core-features">
      <div className="tp-wrap">
        
        <div className="tp-head tp-head--center">
          <span className="tp-eyebrow">CORE FEATURES</span>
          <h2 className="tp-h2">
            Powerful <span>TPMS Capabilities</span>
          </h2>
          <p className="tp-sub">
            Smart monitoring, real-time alerts, and deep analytics — everything you need to manage tire performance efficiently.
          </p>
        </div>

        <div className="cf-grid">
          {features.map((item, index) => (
            <div className="cf-card" key={index}>
              <i className={`bi ${item.icon}`}></i>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
export default ProductDetail126;